// extracted by mini-css-extract-plugin
export default {"container":"Clients_container__Aw76H","title":"Clients_title__x2Wae","companies":"Clients_companies__+8mWn","text":"Clients_text__L+eO4","logo":"Clients_logo__o26pb"};